import { createTheme } from "@mui/material";

const theme = createTheme({
	typography: {
		fontFamily: ["Inter", "sans-serif"].join(","),
	},
	palette: {
		primary: {
			main: "#005a3c",
			dark: "#00381a",
		},
		secondary: {
			main: "#ff5a3c",
		},
		primaryButton: {
			main: "#005a3c",
			dark: "#00381a",
		},
		secondaryButton: {
			main: "#757775",
			dark: "#535553",
		},
	},

	components: {
		MuiTab: {
			styleOverrides: {
				root: {
					fontSize: 11,
					letterSpacing: "-0.2px",
					fontFamily: ["Inter", "sans-serif"].join(","),
					fontWeight: "600",
					"&.Mui-selected": {
						backgroundColor: "rgba(255,255,255,0.1)",
					},
				},
			},
		},
		MuiAlert: {
			styleOverrides: {
				filledSuccess: {
					background: "#005a3c",
					color: "#fff",
				},
			},
		},
	},
});
export default theme;
